module.exports = __webpack_public_path__ + "img/white.b8cb4fc.svg";